import { SmartTable } from '../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        this.st = new SmartTable();
        this.applications.map(application => this.setDisplayNames(application));
    }

    setDisplayNames(application) {
        application.typeDisplayName = this.typeDisplayName(application);
        application.protocolDisplayName = this.protocolDisplayName(application);
    }

    typeDisplayName(app) {
        let displayName = app.publicService ? app.publicService.serviceName + ' - ' + app.applicationTypeDisplayName : app.applicationTypeDisplayName;
        return displayName;
    }

    protocolDisplayName(app) {
        if (app.slug == 'enterprise-password-manager') {
            return 'Enterprise Password Manager';
        } else if (app.slug == 'generic-oauth2') {
            return 'OAUTH2';
        } else if (app.oidc) {
            return 'OIDC';
        } else if (app.vpnRdp) {
            return 'VPN/RDP';
        } else if (app.saml) {
            return 'SAML';
        } else if (app.radius) {
            return 'Radius';
        } else if (app.mfaAdapter) {
            return 'MFA Adapter';
        }
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/manage-applications/added-applications-list/added-applications-list.controller.js